/** The last net under the whole app: a page that throws while rendering shows a plain panel with a way back, never a blank screen. */
import { Component, type ErrorInfo, type ReactNode } from "react";

export const CRASH_LINE = "Something went wrong on this page. Your saved work is safe; reload the page to carry on.";

export class ErrorBoundary extends Component<{ readonly children: ReactNode }, { readonly failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError(): { failed: boolean } { return { failed: true }; }
  override componentDidCatch(error: Error, info: ErrorInfo): void { console.error(error, info.componentStack); }
  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="gx-fullpage" role="alert" data-testid="shell.crashed">
        <h1 className="gx-h1">Something went wrong</h1>
        <p className="gx-muted">{CRASH_LINE}</p>
        <button type="button" className="gx-btn gx-btn--primary" onClick={() => window.location.reload()}>Reload the page</button>
      </div>
    );
  }
}
